/**
 * Date-extensions locale Tibetan [bo]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('bo', {
    monthNames: ['ཟླ་བ་དང་པོ','ཟླ་བ་གཉིས་པ','ཟླ་བ་གསུམ་པ','ཟླ་བ་བཞི་པ','ཟླ་བ་ལྔ་པ','ཟླ་བ་དྲུག་པ','ཟླ་བ་བདུན་པ','ཟླ་བ་བརྒྱད་པ','ཟླ་བ་དགུ་པ','ཟླ་བ་བཅུ་པ','ཟླ་བ་བཅུ་གཅིག་པ','ཟླ་བ་བཅུ་གཉིས་པ'],
    monthShortNames: ['ཟླ་བ་དང་པོ','ཟླ་བ་གཉིས་པ','ཟླ་བ་གསུམ་པ','ཟླ་བ་བཞི་པ','ཟླ་བ་ལྔ་པ','ཟླ་བ་དྲུག་པ','ཟླ་བ་བདུན་པ','ཟླ་བ་བརྒྱད་པ','ཟླ་བ་དགུ་པ','ཟླ་བ་བཅུ་པ','ཟླ་བ་བཅུ་གཅིག་པ','ཟླ་བ་བཅུ་གཉིས་པ'],
    dayNames: ['གཟའ་ཉི་མ་','གཟའ་ཟླ་བ་','གཟའ་མིག་དམར་','གཟའ་ལྷག་པ་','གཟའ་ཕུར་བུ','གཟའ་པ་སངས་','གཟའ་སྤེན་པ་'],
    dayShortNames: ['ཉི་མ་','ཟླ་བ་','མིག་དམར་','ལྷག་པ་','ཕུར་བུ','པ་སངས་','སྤེན་པ་']
});
